export default __webpack_public_path__ + "static/media/drina.1d27f511.png";